import { mulberry32 } from './seededRandom';

const WALK_DUR = 4;      // seconds budgeted per walk leg (lerp handles real arrival)
const IDLE_MIN = 4, IDLE_SPAN = 6;
const INSIDE_MIN = 3, INSIDE_SPAN = 4;

function seededYardPoint(yardPos, rand) {
  return [yardPos[0] + (rand() - 0.5) * 3, yardPos[1], yardPos[2] + (rand() - 0.5) * 2];
}

/**
 * Ambient per-worker movement target for the current frame. Pure + periodic.
 * @param {{elapsed:number, seed:number, yardPos:number[], roomDoorPos:?number[]}} p
 * @returns {{target:number[], phase:'idle'|'walking'|'inside', visible:boolean}}
 */
export function workerRoamPath({ elapsed, seed, yardPos, roomDoorPos }) {
  // Draw order is significant: each rand() advances the seeded sequence, so any new
  // seeded value must be added AFTER these to keep existing workers looking the same.
  const rand = mulberry32((seed >>> 0) || 1);
  const idleDur = IDLE_MIN + rand() * IDLE_SPAN;
  const insideDur = INSIDE_MIN + rand() * INSIDE_SPAN;
  const phaseOffset = rand() * 100;
  // seededYardPoint consumes two more draws — only when the worker is unassigned.
  const dest = roomDoorPos || seededYardPoint(yardPos, rand);

  const cycle = idleDur + WALK_DUR + insideDur + WALK_DUR;
  let t = (((elapsed + phaseOffset) % cycle) + cycle) % cycle;

  if (t < idleDur) return { target: yardPos, phase: 'idle', visible: true };
  t -= idleDur;
  if (t < WALK_DUR) return { target: dest, phase: 'walking', visible: true };
  t -= WALK_DUR;
  if (t < insideDur) return { target: dest, phase: 'inside', visible: !roomDoorPos };
  return { target: yardPos, phase: 'walking', visible: true };
}
